import { useEffect, useState } from 'react';
import { resolveImage } from "../../images/ImageResolver";
import { fetchData } from './Helpers';
import freeImg from '../../images/free-w.svg';
import privateImg from '../../images/private.svg';
import professionalImg from '../../images/professional.svg';

function InfoDropdown({ type, infoData, ui }) {
  return(
    <div className='filings-wealth'>
      {ui === 1 && <ef-layout className="comment-layout">
        <table>
          <thead>
            <tr>
              <th>SEGMENTS</th>
              <th>PLIs</th>
            </tr>
          </thead>
          <tbody>
            {infoData.filter(row => row.category === "PLIs").map((row, index) => (
              <tr key={index}>
                <td>{row["segments"]}</td>
                { type === "free" && <td>{row["public"]}</td> }
                { type === "private" && <td>{row["private"]}</td> }
                { type === "professional" && <td>{row["professional"]}</td> }
              </tr>
            ))}
          </tbody>
        </table>
      </ef-layout>}
      {ui === 2 && <ef-layout className="comment-layout">
        <table>
          <thead>
            <tr>
              <th>SEGMENTS</th>
              <th>WEALTH</th>
            </tr>
          </thead>
          <tbody>
            {infoData.filter(row => row.category === "Wealth").map((row, index) => (
              <tr key={index}>
                <td>{row["segments"]}</td>
                { type === "free" && <td>{row["public"]}</td> }
                { type === "private" && <td>{row["private"]}</td> }
                { type === "professional" && <td>{row["professional"]}</td> }
              </tr>
            ))}
          </tbody>
        </table>
      </ef-layout>}
      {ui === 2 && <ef-layout className="comment-layout">
        <table>
          <thead>
            <tr>
              <th>SEGMENTS</th>
              <th>Capital Markets & Advisory</th>
            </tr>
          </thead>
          <tbody>
            {infoData.filter(row => row.category === "Capital Markets & Advisory").map((row, index) => (
              <tr key={index}>
                <td>{row["segments"]}</td>
                { type === "free" && <td>{row["public"]}</td> }
                { type === "private" && <td>{row["private"]}</td> }
                { type === "professional" && <td>{row["professional"]}</td> }
              </tr>
            ))}
          </tbody>
        </table>
      </ef-layout>}
      {ui === 3 && <ef-layout className="comment-layout">
        <table>
          <thead>
            <tr>
              <th>SEGMENTS</th>
              <th>ENDPOINTS</th>
            </tr>
          </thead>
          <tbody>
            {infoData.filter(row => row.category === "Endpoints").map((row, index) => (
              <tr key={index}>
                <td>{row["segments"]}</td>
                { type === "free" && <td>{row["public"]}</td> }
                { type === "private" && <td>{row["private"]}</td> }
                { type === "professional" && <td>{row["professional"]}</td> }
              </tr>
            ))}
          </tbody>
        </table>
      </ef-layout>}
      <ef-layout>
        <p className='commentP'>*Clients who sign up for private non-professional are allowed to publicly display their own company's filings from the last two years.</p>
      </ef-layout>
      <ef-layout className="events-wealth-bottom-bar">
        { type === "free" &&
        <p className='commentP'>
          <ef-icon icon="admin-profile"></ef-icon>
          Customers redistributing content from the Service externally (outside their Firm) to Users - Defined as Non-Professional users via a public application, e.g. via public website, with no password protection.
        </p>
        }
        { type === "private" &&
        <p className='commentP'>
          <ef-icon icon="admin-profile"></ef-icon>
          Customers redistributing content from the Service externally (outside their Firm) to Users - Defined as Non-Professional users. Access to the data is password protected.
        </p>
        }
        { type === "professional" &&
        <p className='commentP'>
          <ef-icon icon="admin-profile"></ef-icon>
          Data displayed in Internal applications for internal Wealth Management Professional users only. Access to the data is password protected.
        </p>
        }
      </ef-layout>
    </div>
  );
}

function Package({type, infoData}) {
  const [ui,setUi] = useState(1);

  return(
    <div className='public-div'>
      <ef-tab-bar level="3">
        <ef-tab label="PLI" value="tab1" active onClick={() => setUi(1)}></ef-tab>
        <ef-tab label="Information" value="tab2" onClick={() => setUi(2)}></ef-tab>
        <ef-tab label="Endpoints" value="tab3" onClick={() => setUi(3)}></ef-tab>
      </ef-tab-bar>
      <ef-layout className="package-layout">
        <InfoDropdown type={type} infoData={infoData} ui={ui} />
      </ef-layout>
    </div>
  );
}

export default function WealthPackages() {
  const [packageLayout, setPackageLayout] = useState("free");
  const [infoData, setInfoData] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    fetchData("Filings_Segmentation").then(res => {
      setInfoData(res);
      setDataLoaded(true);
    });
  }, []);

  useEffect(() => {
    const buttonBar = document.getElementById('wealthBar');
    buttonBar.addEventListener('click', (event) => {
      let buttonId = '';
      if(event.target.getAttribute('id')) {
        buttonId = event.target.getAttribute('id');
      }else {
        buttonId = event.target.parentElement.getAttribute('id');
      }
      const buttons = buttonBar.querySelectorAll('ef-button');
      buttons.forEach(btn => {
        btn.active = false;
        btn.children[0].src = resolveImage(btn.getAttribute('id'));
      });
      const btn = document.getElementById(buttonId);
      btn.active = true;
      btn.children[0].src = resolveImage(`${buttonId}-w`);
      setPackageLayout(buttonId);
    });
  }, []);

  return (
    <div className='wealth-packages'>
      <ef-loader class="loader" hidden={dataLoaded}></ef-loader>
      <h4>WEALTH PACKAGES</h4>
      <ef-layout flex>
        <ef-layout>
          <ef-button-bar id="wealthBar">
            <ef-button-bar managed>
              <ef-button id="free" toggles active><img src={freeImg} alt="Public"/>Public</ef-button>
              <ef-button id="private" toggles><img src={privateImg} alt="Private"/>Private</ef-button>
              <ef-button id="professional" toggles><img src={professionalImg} alt="Professional"/>Professional</ef-button>
            </ef-button-bar>
          </ef-button-bar>
        </ef-layout>
      </ef-layout>
      {packageLayout === "free" && <Package type="free" infoData={infoData} />}
      {packageLayout === "private" && <Package type="private" infoData={infoData} />}
      {packageLayout === "professional" && <Package type="professional" infoData={infoData} />}
    </div>
  );
}